/**
 * swatch-keyboard.js
 *
 * Accessibility fix for variant swatch selection (color/size/etc.), used on
 * both the main product page and the Quick View modal since both render the
 * same snippets/product-form.liquid markup.
 * (Skies — Ski Barn accessibility issue #37)
 *
 * The theme renders each swatch option as a plain <div data-swatch-item>
 * with a click-only jQuery handler bound in theme.min.js. product-form.liquid
 * now bakes in role="button", tabindex="0", aria-pressed and aria-label on
 * these divs so they're reachable and correctly announced on first render —
 * but two gaps remain that only JS can close:
 *
 *   1. There is no keydown handler, so Enter/Space do nothing even though
 *      the div is now focusable.
 *   2. aria-pressed is only correct at render time. Clicking (or now,
 *      Enter/Space-ing) a swatch makes the theme's own script toggle the
 *      "is--selected" class between sibling divs, but nothing updates
 *      aria-pressed to match, so a screen reader would keep announcing the
 *      old selection.
 *
 * This file only adds behavior on top of the existing click handler — it
 * never touches theme.min.js.
 */
(function () {
  'use strict';

  // 1. Enter/Space on a swatch triggers the existing click handler.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;

    var target = event.target;
    if (!target || !target.hasAttribute || !target.hasAttribute('data-swatch-item')) return;

    event.preventDefault();
    target.click();
  });

  // 2. Keep aria-pressed in sync with the "is--selected" class, however it
  // gets toggled (mouse click or the keydown bridge above), and however the
  // markup got onto the page (full page load or Quick View's AJAX render).
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var el = mutations[i].target;
      if (!el || !el.hasAttribute || !el.hasAttribute('data-swatch-item')) continue;
      var pressed = el.classList.contains('is--selected') ? 'true' : 'false';
      if (el.getAttribute('aria-pressed') !== pressed) {
        el.setAttribute('aria-pressed', pressed);
      }
    }
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
    subtree: true
  });
})();
